export default [
  {
    code: "GENERAL_DATA",
    index: 0,
    title: "Offer.Steps.GeneralData",
    route: `/insurance-documents/{id}/generalData`,
    disabled: false
  },
  {
    code: "QUOTATION_DATA",
    index: 1,
    title: "Offer.Steps.OfferData",
    route: `/insurance-documents/{id}/offers`,
    disabled: false
  },
  {
    code: "GENERATION_DATA",
    index: 2,
    title: "Offer.Steps.PolicyData",
    route: `/insurance-documents/{id}/policy`,
    disabled: false
  }
];
